import { render, staticRenderFns } from "./NatConLomAwardEdit.vue?vue&type=template&id=31671a65"
import script from "./NatConLomAwardEdit.vue?vue&type=script&lang=js"
export * from "./NatConLomAwardEdit.vue?vue&type=script&lang=js"
import style0 from "./NatConLomAwardEdit.vue?vue&type=style&index=0&id=31671a65&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports